import apiClient from './client';

const BASE = '/wp-json/pfandpirat/v1/drink-collection';

function queryString(params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== '' && value !== null && value !== undefined) query.set(key, String(value));
  });
  return query.toString();
}

export async function loadDrinkCollection(params = {}, signal) {
  const response = await fetch(`${BASE}?${queryString(params)}`, {
    credentials: 'include', cache: 'no-store', signal,
    headers: { 'X-WP-Nonce': window?.pfandpiratData?.nonce || '' },
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new Error(data?.message || 'Das Getränke-Logbuch konnte nicht geladen werden.');
  return data;
}

export function loadDrinkCollectionSummary() {
  return apiClient.get(`${BASE}/summary`);
}

export function loadDrinkDetail(id) {
  return apiClient.get(`${BASE}/${Number(id)}`);
}
